<template>
    <v-container fluid>
        <!-- Search bar -->
        <v-row align="center">
            <v-col cols="12" class="text-right mb-2">
                <!-- Button to open add notice dialog -->
                <v-btn small color="primary" dark @click="openDialog">
                    <v-icon small class="mr-2">mdi-plus</v-icon>FAIRE UNE DENONCIATION
                </v-btn>
            </v-col>
        </v-row>

        <!-- Dialog for adding new notice -->
        <v-dialog v-model="dialog" max-width="800px" persistent>
            <v-card>
                <v-card-title>
                    <h4 class="headline">{{ formTitle }}</h4>
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="12">
                            <!-- Selection field for declaration type -->
                            <v-select v-model="typeDenonciation"
                                :items="['Dénonciation anonyme', 'Dénonciation identifiée']"
                                label="Type de déclaration"></v-select>
                        </v-col>
                        <!-- Display specific fields based on declaration type -->
                        <v-col v-if="typeDenonciation === 'Dénonciation anonyme'" cols="12">
                            <v-text-field v-model="denonciationObjet" label="Objet de la dénonciation"></v-text-field>
                            <v-textarea v-model="denonciationDescription"
                                label="Description de la dénonciation"></v-textarea>
                            <v-file-input v-model="pieceJointe" placeholder="Charger le fichier" label="Pièces jointes"
                                multiple prepend-icon="mdi-paperclip">
                                <template v-slot:selection="{ text }">
                                    <v-chip small label color="primary">{{ text }}</v-chip>
                                </template>
                            </v-file-input>
                        </v-col>
                        <v-col v-else cols="12">
                            <!-- Fields for identified declaration -->
                            <v-row>
                                <v-col cols="6">
                                    <v-text-field v-model="nom" label="Nom"></v-text-field>
                                </v-col>
                                <v-col cols="6">
                                    <v-text-field v-model="prenom" label="Prénom"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="6">
                                    <v-text-field v-model="email" label="Email"></v-text-field>
                                </v-col>
                                <v-col cols="6">
                                    <v-text-field v-model="denonciationObjet" label="Objet de la dénonciation"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-textarea v-model="denonciationDescription"
                                label="Description de la dénonciation"></v-textarea>
                            <v-file-input v-model="pieceJointe" placeholder="Charger les fichiers" label="Pièces jointes"
                                multiple prepend-icon="mdi-paperclip">
                                <template v-slot:selection="{ text }">
                                    <v-chip small label color="primary">{{ text }}</v-chip>
                                </template>
                            </v-file-input>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn small color="red darken-1" text @click="closeDialog">
                        ANNULER
                    </v-btn>
                    <v-btn small color="green darken-1" text @click="addDemande">
                        ENVOYER LA DEMANDE
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Data table for displaying exclusions -->
        <v-data-table locale="fr" :headers="headers" :search="search" no-data-text="Aucune dénonciation trouvée"
            :items="this.$store.getters['Auth/getDenonciation']" @click:row="goto" class="elevation-1 mb-5 px-5">
            <!-- Slot for custom row rendering -->

            <template v-slot:[`item.dateDenonciation`]="{ item }">{{
                    item.dateDenonciation | moment("DD MMMM YYYY")
                }}</template>
        </v-data-table>
    </v-container>
</template>

<script>
import { mapActions } from "vuex";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

export default {
    components: { DatePicker },
    data: () => ({
        search: "",
        dialog: false,
        formTitle: "ENVOYER LA DENONCIATION",
        typeDenonciation: 'Dénonciation anonyme',
        nom: '',
        prenom: '',
        email: '',
        denonciationObjet: '',
        denonciationDescription: '',
        pieceJointe: null,
        headers: [
            { text: "type Dénonciation", align: "start", sortable: false, value: "typeDenonciation" },
            { text: "Objet Dénonciation", sortable: false, value: "denonciationObjet" },
            { text: "Date de Dénonciation", sortable: false, value: "dateDemande" },
        ],
    }),
    created() {
        this.$store.dispatch("Auth/loadAllDenonciationByUser");
        this.$store.dispatch("Auth/getData");
    },
    methods: {
        ...mapActions({
            loadAllDemandeQuitus: "Auth/loadAllDenonciationByUser",
            sendDenonciation: "Auth/addDenonciation"
        }),
        openDialog() {
            this.dialog = true;
        },
        closeDialog() {
            this.dialog = false;
        },
        goto(value) {
            const { id } = value;
            this.$router.push({ name: "show_mes_denonciations", params: { id: id } });
        },
        addDemande() {
            const data = new FormData();
            data.append("typeDenonciation", this.typeDenonciation);
            if (this.typeDenonciation === 'Dénonciation identifiée') {
                data.append("nom", this.nom);
                data.append("prenom", this.prenom);
                data.append("email", this.email);
            }
            data.append("denonciationObjet", this.denonciationObjet);
            data.append("denonciationDescription", this.denonciationDescription);
            if (this.pieceJointe) {
             data.append("pieceJointe", this.pieceJointe[0]);
            }

            this.sendDenonciation(data);

            // Réinitialiser les champs du formulaire après l'envoi
            this.typeDenonciation = 'Dénonciation anonyme';
            this.nom = '';
            this.prenom = '';
            this.email = '';
            this.denonciationObjet = '';
            this.denonciationDescription = '';
            this.pieceJointe = null;

            this.dialog = false;
        },
    }
};
</script>

<style></style>
